import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import CreateAxios from '../axiosComponent/create';
const MyCity = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        // $("#searchType .dropdown").removeClass("dropdown")
    }, [])
    let handleSearch = (e, data) => {
        if (data.searchQuery) {
            setloading(true)
            let searchTerm = data.searchQuery
            CreateAxios({ completeURL: `${process.env.REACT_APP_MASTER_API}/cityMaster`, payload: { searchTerm: searchTerm } })
                .then((result) => {
                    console.log("Result : ", result.data.resultSet)
                    setcontent(result.data.resultSet)
                    setloading(false)
                })
        }
    }
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.cityCode
            temp.text = object.cityName
            temp.value = object.cityName
            // temp.value = { latitude: object.lattitude, longitude: object.longitude }
            return options[index] = temp
        })
    }


    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
        content.filter((item) => {
            if (data.value === item.cityName) {
                props.getCityInfo(item)
                // setdriverContact(item.driverContact)
                // setdriverLic(item.driverLicense)

                console.log('>>>', item)
            }
        })
        console.log("SHARON TEST : ", data.value)
    }
    // console.log('>>',content)
    return (
        <Dropdown
            selection
            search
            clearable
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            // id="searchType"
            error={props.error}
            onSearchChange={handleSearch}
            noResultsMessage="Search for Result"
            {...props}
        />
    )
}
export default MyCity